import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import workerHasPrivilege from "../../../../utils/workerHasPrivilege";
import AppTable from "../../../../componentsReusable/AppTable";
import moment from "moment";
import ClientLabel from "../../../Client/ClientLabel";
import PriceFormatted from "../../../Application/PriceFormatted";
import displayDependentOnShowPrice from "../../../../utils/displayDependentOnShowPrice";
import apiPlatform from "../../../../apiPlatform";
import {useTranslation} from "react-i18next";
import {getWarehouseDocumentIncomeTypes} from "../../../../utils/documentsTypeName";
import WarehouseDocumentLabel from "../../WarehouseDocument/WarehouseDocumentLabel";

const WarehouseDocumentItemTable = props => {
  const { t } = useTranslation('warehouse_document_item_table')
  const [data, setData] = React.useState(null);
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    setLoading(true);
    const params = new URLSearchParams({
      product: props.productId,
      page: '1',
      itemsPerPage: '5000',
      'order[document.date]': 'desc',
      'order[document.id]': 'desc',
      'type': getWarehouseDocumentIncomeTypes(),
    });

    apiPlatform.warehouseDocuments.item.list(params.toString())
      .then(res => {
        setData(res.data['hydra:member']);
        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
      });
  }, [props.productId]);

  return (
    <>
      {workerHasPrivilege('warehouses.globalPreview') && <div className="flex-grow-1">
        {!loading ? (
          <div className="mt-2">
            <AppTable
              tableSize={'sm'}
              pagination={false}
              searchable={false}
              disableMinHeightTable
              maxHeight={'35vh'}
              columns={[
                {
                  dataField: 'document.date',
                  text: t('table.columns.date'),
                  headerStyle: {
                    width: 78
                  },
                  formatter: (cell, row) => {
                    return moment(row.documentDate).format('YYYY-MM-DD')
                  },
                },
                {
                  dataField: 'client',
                  text: t('table.columns.client'),
                  disabled: !workerHasPrivilege('clients.view'),
                  headerStyle: {
                    width: 130
                  },
                  formatter: (cell, row) => <div className="d-flex flex-row flex-nowrap justify-content-between">
                    <div className="text-truncate"><ClientLabel client={row.client}/></div>

                    <WarehouseDocumentLabel warehouseDocumentId={row.documentId} number={row.documentNumber} linkText={false} />
                  </div>
                },
                {
                  dataField: 'price',
                  disabled: !workerHasPrivilege('repairOrders.priceVisibility'),
                  text: t('table.columns.price'),
                  headerStyle: {
                    width: 62
                  },
                  align: 'right',
                  headerAlign: 'right',
                  formatter: (cell, row) => <PriceFormatted value={displayDependentOnShowPrice(row.priceNet, row.priceGross)}/>
                },
                {
                  dataField: 'count',
                  text: t('table.columns.count'),
                  headerStyle: {
                    width: 72
                  },
                  align: 'right',
                  headerAlign: 'right',
                  formatter: (cell, row) => row.count
                },
                {
                  dataField: 'available',
                  text: t('table.columns.available'),
                  headerStyle: {
                    width: 62
                  },
                  align: 'right',
                  headerAlign: 'right',
                  formatter: (cell, row) => Math.round(row.count - row.used, 2)
                },
              ]}
              data={data}
            />

          </div>) : (<div className="mt-2 text-center">
          {t('table.data_loading')}
        </div>)}
      </div>}
    </>
  );
};

WarehouseDocumentItemTable.propTypes = {
  productId: PropTypes.number.isRequired
};

export default WarehouseDocumentItemTable;